import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { professorLoginResponse } from '../models/entities/professor-login-response';
import { professorLoginRequest } from '../models/requests/professor-login';

@Injectable({
  providedIn: 'root'
})
export class LoginProfessorService {
  controller = 'CuentaDocente';
constructor(private _http: HttpClient) {}

  loginProfessor(professor: professorLoginRequest): Observable<professorLoginResponse> {
    return this._http.post<professorLoginResponse>(
      `${environment.url_api}${this.controller}/login-docente`,
      professor
    );
  }
}